export const handleResetChipsScale = (e: any) => {
  for (let index = 0; index < e.slides.length; index++) {
    if (index !== e.activeIndex) {
      e.slides[index].style.transform = `scale(1)`
      e.slides[e.activeIndex].style.transform = 'scale(1.36)'
      e.slides[index].firstChild.style.background = `rgb(26, 68, 108)`
      e.slides[e.activeIndex].firstChild.style.background = 'rgb(255, 176, 0)'
      e.slides[index].style.transition = `all 0.2s`
      e.slides[e.activeIndex].style.transform = 'all 0.2s'
      e.slides[e.activeIndex].firstChild.style.borderColor = 'rgb(255, 176, 0)'
      e.slides[e.activeIndex].firstChild.firstChild.style.borderColor = 'rgb(26, 68, 108)'
      e.slides[e.activeIndex].firstChild.firstChild.style.color = 'rgb(26, 68, 108)'
      e.slides[index].firstChild.style.borderColor = 'rgb(26, 68, 108)'
      e.slides[index].firstChild.firstChild.style.borderColor = 'rgb(255, 176, 0)'
      e.slides[index].firstChild.firstChild.style.color = 'rgb(255, 176, 0)'
    }
  }
}